import React from "react";
import styled from "styled-components/macro";
import { toRem } from "theme/Breakpoints";
import { defaultHorizontalMargin, DefaultText } from "theme/GlobalElements";
import { colors } from "theme/Theme";

interface FooterSectionProps {
  title: string;
  children: any;
}

const FooterSection: React.FC<FooterSectionProps> = ({ title, children }) => {
  return (
    <FooterSectionContainer>
      <Title className="text-body">{title}</Title>
      {children}
    </FooterSectionContainer>
  );
};

const FooterSectionContainer = styled.div`
  width: ${toRem(265)};
  height: 100%;
  ${defaultHorizontalMargin};
  padding: 40px 0 40px;
  justify-content: flex-start;
  display: flex;
  flex-direction: column;
`;
const Title = styled.p`
  font-weight: 700;
  margin-bottom: 10px;
  color: white;
`;

export default FooterSection;
